import store from "@packages/store";
import Vue from "vue";

export default {
    async find(id) {
        return await Vue.api.establishments.find(id);
    },    

    async getAdvertisers(filter) {
        const advertisers = await Vue.api.establishments.getAdvertisers({
            filter,
        });

        store.commit("SET_ADVERTISERS", advertisers);

        return advertisers;
    },
};
